import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import { COOKIE } from "~/const/cookie";

import { useFetchViewerVideoPriceDropNotificationsQuery } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";
import { getCookie } from "~/util/get-cookie";

export const useCheckPriceDownNotice = () => {
  const { events } = useRouter();
  const { isLoggedIn } = useAuth();
  const { data } = useFetchViewerVideoPriceDropNotificationsQuery({
    skip: !isLoggedIn,
  });

  const currentNoticeLength = data?.viewer.videoPriceDropNotifications.edges.length ?? 0;
  const previousNoticeLength = getCookie(COOKIE.PRICE_DOWN_NOTICE_LENGTH.KEY);
  const isAlreadyNotifiedPriceDown = getCookie(COOKIE.NOTIFIED_PRICE_DOWN.KEY) !== undefined;

  const isChangedNoticeLength = useMemo(() => {
    if (previousNoticeLength === undefined) return false;
    return currentNoticeLength !== Number(previousNoticeLength);
  }, [currentNoticeLength, previousNoticeLength]);

  /** 値下げ通知表示判定フラグ */
  const shouldShowPriceDownNotice = useMemo(() => {
    if (currentNoticeLength === 0) return false;
    if (isChangedNoticeLength) return true;
    return !isAlreadyNotifiedPriceDown;
  }, [isAlreadyNotifiedPriceDown, currentNoticeLength, isChangedNoticeLength]);

  useEffect(() => {
    if (!shouldShowPriceDownNotice) return;
    if (currentNoticeLength === 0) return;
    // memo: (okita) cookieにprevNoticeLengthの値が存在しない場合は書き込む、また差分が発生した場合は更新する
    if (previousNoticeLength === undefined || isChangedNoticeLength) {
      document.cookie = `${COOKIE.PRICE_DOWN_NOTICE_LENGTH.KEY}=${currentNoticeLength}`;
      // 通知件数に変更があった時は通知済みフラグをリセットする
      document.cookie = `${COOKIE.NOTIFIED_PRICE_DOWN.KEY}=; max-age=0`;
    }
  }, [currentNoticeLength, previousNoticeLength, isChangedNoticeLength]);

  /** 値下げ通知を表示後画面遷移時にcookieをセットし非表示にするフラグをsetする */
  const onBeforeChange = () => {
    if (!shouldShowPriceDownNotice) return;
    document.cookie = `${COOKIE.NOTIFIED_PRICE_DOWN.KEY}=${COOKIE.NOTIFIED_PRICE_DOWN.VALUE}`;
  };

  useEffect(() => {
    events.on("routeChangeStart", onBeforeChange);
    return () => {
      events.off("routeChangeStart", onBeforeChange);
    };
  }, [shouldShowPriceDownNotice]);

  return {
    shouldShowPriceDownNotice,
  };
};
